import React from 'react';
import * as Icons from 'react-icons/fa';
import './ModuleCard.css';
import { useNavigate } from 'react-router-dom';

const isDark = document.body.classList.contains('dark-mode');

const statusIcon = {
  liberado: Icons.FaCheckCircle,
  upsell: Icons.FaRocket,
  bloqueado: Icons.FaLock,
};

const statusTooltip = {
  liberado: 'Acesso liberado',
  upsell: 'Disponível com upgrade',
  bloqueado: 'Acesso bloqueado',
};

const ModuleCard = ({
  titulo,
  tipo,
  icone,
  status,
  imagem,
  acao = "interna",
  destino = "",
  destino_final = null,
  conteudo_html = null
}) => {
  const navigate = useNavigate();
  const IconStatus = statusIcon[status] || Icons.FaLock;
  const tooltipText = statusTooltip[status] || 'Status desconhecido';

  const urlFinal = destino_final || destino;

  const handleClick = () => {
    const urlFinal = destino_final || destino;
    console.log("🔗 Navegar para:", urlFinal, "| Ação:", acao, "| Status:", status);

    if (status === 'upsell') {
      navigate('/upsell');
      return;
    }

    switch (acao) {
      case 'interna':
        if (urlFinal) navigate(urlFinal);
        break;
      case 'externa':
        if (urlFinal) window.open(urlFinal, '_blank');
        break;
      case 'iframe':
        if (urlFinal) navigate(`/iframe?url=${encodeURIComponent(urlFinal)}`);
        break;
      case 'modal':
        if (conteudo_html) {
          alert("Abrir modal com conteúdo:\n\n" + conteudo_html);
        }
        break;
      case 'pdf':
        if (urlFinal) navigate(`/visualizar-pdf?url=${encodeURIComponent(urlFinal)}`);
        break;
      default:
        console.warn("Ação desconhecida:", acao);
    }
  };


  return (
    <div
      className={`module-card ${status}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter') handleClick(); }}
      aria-label={`Módulo ${titulo}, tipo ${tipo}, status ${status}`}
    >
      <div
        className="module-image"
        style={{
          backgroundImage: `url(${imagem && imagem !== "null" ? encodeURI(imagem) : "https://universo.youevolution.com.br/uploads/capas/placeholder.jpg"})`
        }}
      >
        <div className="module-overlay">
          <div className="module-top" title={tooltipText}>
            <IconStatus className="module-status" />
          </div>
          <div className="module-info">
            <h4>{titulo}</h4>
            {/* <p className="module-tipo">{tipo}</p> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModuleCard;
